import { render, staticRenderFns } from "./DiscoverItems.vue?vue&type=template&id=70e667d5&scoped=true&"
import script from "./DiscoverItems.vue?vue&type=script&lang=js&"
export * from "./DiscoverItems.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverItems.vue?vue&type=style&index=0&id=70e667d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e667d5",
  null
  
)

export default component.exports